import type { JSX } from 'react';
import type { IntlShape } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import AppStore from '../StoreBadges/AppStore';
import GooglePlay from '../StoreBadges/GooglePlay';
import styles from './styles.module.scss';

type AppForOutdoorsProps = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  noReferrerAppLinks?: boolean;
};

const AppForOutdoors = ({ languageRegionCode, noReferrerAppLinks = true, intl }: AppForOutdoorsProps): JSX.Element => (
  <div className={styles.container}>
    <Typography className={styles.title} component="h2" mt="0" variant="text300bold" color="inverse" >
      {intl.formatMessage({ defaultMessage: 'An app for the outdoors' })}
    </Typography>
    <div className={styles.appIconsContainer}>
      <AppStore height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} intl={intl} />
      <GooglePlay height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} intl={intl} />
    </div>
  </div>
);

export default AppForOutdoors;
